let baseShip = {
  firstName: 'john',
  lastName: 'doe',
  address1: '5 memory lane',
  address2: 'apt 9201',
  address3: '',
  city: 'cupertino',
  zip: '92010',
  state: 'CA',
  country: 'US'
}
let baseData = {
  profileName: 'alala',
  email: 'hey@graffixed.com',
  phone: '555-555-5555',
  card: {
    type: 'visa',
    month: '02',
    year: '2022',
    code: '020',
    number: '41111111111'
  },
  billing: baseShip,
  shipping: baseShip,
  matchInfo: true,
}
export default baseData